import React from 'react'
import { Box, Typography } from '@mui/material'
import FixedWidthContainer from 'components/FixedWidthContainer'
import DealerSignupSection from 'components/DealerSignupSection'
import SectionHeader from 'components/SectionHeader'
import { useTranslation } from 'react-i18next'

const WarrantyPage = () => {
  const { t } = useTranslation()
  return (
    <Box>
      <FixedWidthContainer>
        <SectionHeader title={t('warranty.title')} />

        <Box>
          <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
            {t('warranty.subtitle')}
          </Typography>

          <Typography
            variant='body1'
            sx={{ mt: 4, color: '#7C7C7C' }}
            gutterBottom
          >
            {t('warranty.paragraph1')}
          </Typography>
          <Typography
            variant='body1'
            sx={{ mt: 4, color: '#7C7C7C' }}
            gutterBottom
          >
            {t('warranty.paragraph2')}
          </Typography>
          <Typography
            variant='body1'
            sx={{ mt: 4, color: '#7C7C7C' }}
            gutterBottom
          >
            {t('warranty.paragraph3')}
          </Typography>
          <Typography
            variant='body1'
            sx={{ mt: 4, color: '#7C7C7C' }}
            gutterBottom
          >
            {t('warranty.paragraph4')}
          </Typography>
          <Typography
            variant='body1'
            sx={{ my: 4, color: '#7C7C7C' }}
            gutterBottom
          >
            {t('warranty.paragraph5')}
          </Typography>
        </Box>
      </FixedWidthContainer>
      <DealerSignupSection />
    </Box>
  )
}

export default WarrantyPage
